/* eslint-disable */
import * as Types from '../../graphql/types';

import { gql } from '@apollo/client';
import * as Apollo from '@apollo/client';
const defaultOptions = {} as const;

export const CountriesDocument = gql`
    query Countries {
  countries {
    id
    title
  }
}
    `;

/**
 * __useCountriesQuery__
 *
 * To run a query within a React component, call `useCountriesQuery` and pass it any options that fit your needs.
 * When your component renders, `useCountriesQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useCountriesQuery({
 *   variables: {
 *   },
 * });
 */
export function useCountriesQuery(baseOptions?: Apollo.QueryHookOptions<CountriesQuery, CountriesQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<CountriesQuery, CountriesQueryVariables>(CountriesDocument, options);
      }
export function useCountriesLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<CountriesQuery, CountriesQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<CountriesQuery, CountriesQueryVariables>(CountriesDocument, options);
        }
// @ts-ignore
export function useCountriesSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<CountriesQuery, CountriesQueryVariables>): Apollo.UseSuspenseQueryResult<CountriesQuery, CountriesQueryVariables>;
export function useCountriesSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<CountriesQuery, CountriesQueryVariables>): Apollo.UseSuspenseQueryResult<CountriesQuery | undefined, CountriesQueryVariables>;
export function useCountriesSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<CountriesQuery, CountriesQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<CountriesQuery, CountriesQueryVariables>(CountriesDocument, options);
        }
export type CountriesQueryHookResult = ReturnType<typeof useCountriesQuery>;
export type CountriesLazyQueryHookResult = ReturnType<typeof useCountriesLazyQuery>;
export type CountriesSuspenseQueryHookResult = ReturnType<typeof useCountriesSuspenseQuery>;
export type CountriesQueryResult = Apollo.QueryResult<CountriesQuery, CountriesQueryVariables>;
export const CitiesByCountryDocument = gql`
    query CitiesByCountry($countryId: Int!, $limit: Int, $afterValue: String, $afterId: Int, $order: String, $field: String, $search: String) {
  citiesByCountry(
    countryId: $countryId
    limit: $limit
    afterValue: $afterValue
    afterId: $afterId
    order: $order
    field: $field
    search: $search
  ) {
    id
    title
  }
}
    `;

/**
 * __useCitiesByCountryQuery__
 *
 * To run a query within a React component, call `useCitiesByCountryQuery` and pass it any options that fit your needs.
 * When your component renders, `useCitiesByCountryQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useCitiesByCountryQuery({
 *   variables: {
 *      countryId: // value for 'countryId'
 *      limit: // value for 'limit'
 *      afterValue: // value for 'afterValue'
 *      afterId: // value for 'afterId'
 *      order: // value for 'order'
 *      field: // value for 'field'
 *      search: // value for 'search'
 *   },
 * });
 */
export function useCitiesByCountryQuery(baseOptions: Apollo.QueryHookOptions<CitiesByCountryQuery, CitiesByCountryQueryVariables> & ({ variables: CitiesByCountryQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<CitiesByCountryQuery, CitiesByCountryQueryVariables>(CitiesByCountryDocument, options);
      }
export function useCitiesByCountryLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<CitiesByCountryQuery, CitiesByCountryQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<CitiesByCountryQuery, CitiesByCountryQueryVariables>(CitiesByCountryDocument, options);
        }
// @ts-ignore
export function useCitiesByCountrySuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<CitiesByCountryQuery, CitiesByCountryQueryVariables>): Apollo.UseSuspenseQueryResult<CitiesByCountryQuery, CitiesByCountryQueryVariables>;
export function useCitiesByCountrySuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<CitiesByCountryQuery, CitiesByCountryQueryVariables>): Apollo.UseSuspenseQueryResult<CitiesByCountryQuery | undefined, CitiesByCountryQueryVariables>;
export function useCitiesByCountrySuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<CitiesByCountryQuery, CitiesByCountryQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<CitiesByCountryQuery, CitiesByCountryQueryVariables>(CitiesByCountryDocument, options);
        }
export type CitiesByCountryQueryHookResult = ReturnType<typeof useCitiesByCountryQuery>;
export type CitiesByCountryLazyQueryHookResult = ReturnType<typeof useCitiesByCountryLazyQuery>;
export type CitiesByCountrySuspenseQueryHookResult = ReturnType<typeof useCitiesByCountrySuspenseQuery>;
export type CitiesByCountryQueryResult = Apollo.QueryResult<CitiesByCountryQuery, CitiesByCountryQueryVariables>;
export const TimezonesDocument = gql`
    query Timezones($field: String, $order: String) {
  timezones(field: $field, order: $order) {
    id
    name
    timeOffset
    timeOffsetDst
    gMT
  }
}
    `;

/**
 * __useTimezonesQuery__
 *
 * To run a query within a React component, call `useTimezonesQuery` and pass it any options that fit your needs.
 * When your component renders, `useTimezonesQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useTimezonesQuery({
 *   variables: {
 *      field: // value for 'field'
 *      order: // value for 'order'
 *   },
 * });
 */
export function useTimezonesQuery(baseOptions?: Apollo.QueryHookOptions<TimezonesQuery, TimezonesQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<TimezonesQuery, TimezonesQueryVariables>(TimezonesDocument, options);
      }
export function useTimezonesLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<TimezonesQuery, TimezonesQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<TimezonesQuery, TimezonesQueryVariables>(TimezonesDocument, options);
        }
// @ts-ignore
export function useTimezonesSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<TimezonesQuery, TimezonesQueryVariables>): Apollo.UseSuspenseQueryResult<TimezonesQuery, TimezonesQueryVariables>;
export function useTimezonesSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<TimezonesQuery, TimezonesQueryVariables>): Apollo.UseSuspenseQueryResult<TimezonesQuery | undefined, TimezonesQueryVariables>;
export function useTimezonesSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<TimezonesQuery, TimezonesQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<TimezonesQuery, TimezonesQueryVariables>(TimezonesDocument, options);
        }
export type TimezonesQueryHookResult = ReturnType<typeof useTimezonesQuery>;
export type TimezonesLazyQueryHookResult = ReturnType<typeof useTimezonesLazyQuery>;
export type TimezonesSuspenseQueryHookResult = ReturnType<typeof useTimezonesSuspenseQuery>;
export type TimezonesQueryResult = Apollo.QueryResult<TimezonesQuery, TimezonesQueryVariables>;
export type CountriesQueryVariables = Types.Exact<{ [key: string]: never; }>;


export type CountriesQuery = { __typename?: 'Query', countries: Array<{ __typename?: 'GraphCountry', id?: number | null, title: string }> };

export type CitiesByCountryQueryVariables = Types.Exact<{
  countryId: Types.Scalars['Int']['input'];
  limit?: Types.InputMaybe<Types.Scalars['Int']['input']>;
  afterValue?: Types.InputMaybe<Types.Scalars['String']['input']>;
  afterId?: Types.InputMaybe<Types.Scalars['Int']['input']>;
  order?: Types.InputMaybe<Types.Scalars['String']['input']>;
  field?: Types.InputMaybe<Types.Scalars['String']['input']>;
  search?: Types.InputMaybe<Types.Scalars['String']['input']>;
}>;


export type CitiesByCountryQuery = { __typename?: 'Query', citiesByCountry: Array<{ __typename?: 'GraphCity', id?: number | null, title: string }> };

export type TimezonesQueryVariables = Types.Exact<{
  field?: Types.InputMaybe<Types.Scalars['String']['input']>;
  order?: Types.InputMaybe<Types.Scalars['String']['input']>;
}>;


export type TimezonesQuery = { __typename?: 'Query', timezones: Array<{ __typename?: 'GraphTimezone', id?: number | null, name: string, timeOffset?: number | null, timeOffsetDst?: number | null, gMT?: string | null }> };
